import React,{ useEffect, useState}  from 'react';
import { FaAngleDoubleUp } from "react-icons/fa";
import '../assets/scss/ScollToTop.scss'

const ScrollToTop = () => {
    const [showScrollTopBottom, setShowScrollTopBottom] = useState(false);

    useEffect(()=> {
        window.addEventListener("scroll", () => {

        if(window.scrollY > 300) {
            setShowScrollTopBottom(true)
        } else {
            setShowScrollTopBottom(false)
        }
    });
    }, []);

    const windowTop = () => {
        window.scrollTo( {
            top:0,
            behavior:'smooth',          
        })
    }

    return (
        <div className='scrollToTopIcon'>
         { showScrollTopBottom &&  (<div onClick={windowTop} className='scroll-up  bg-slate-400 hover:bg-violet-300'><FaAngleDoubleUp className="up-icon"/></div>)}
        </div>
    )

}

export default ScrollToTop